function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
// 图片资源库
import { ResourceCategory } from "@ps/bridge/resource/pool/type";
import i18n from "@ps/lang";
import { ResourceAccepts } from "@ps/views/workbench/resource-manager/resource";
// ResTypeModel        = 1  // 模型（旧）
// ResTypeAction       = 2  // 动作（旧）
// ResType2DAnimation  = 3  // 2D动画（旧）
// ResTypeVideo        = 5  // 视频
// ResTypeBGM          = 6  // 背景音乐库
// ResTypeFinger       = 7  // 手指库
// ResTypeBackground   = 8  // 背景库
// ResTypeCTABtn       = 9  // CTA按钮库
// ResTypeEffect       = 10 // 特效库（原：序列帧）
// ResTypeActor        = 11 // 主角库
// ResTypeSlogan       = 12 // 文本库
// ResTypeImage        = 13 // 图片库
// ResTypeDialog       = 14 // 对话框库
// ResTypeSoundEffects = 15 // 音效库
// ResSceneEffects = 16 // 场景模板库
// 临时配置，是否显示资源库的 tab，后续会会删除，默认都是用资产库资源
// PT 改版套餐上线之后，这里默认都是 true
export var isAssetMode = true;
export var commonImageComponentTypes = {
    finger: 7,
    background: 8,
    ctaButton: 9,
    image: 13,
    dialog: 14,
    progressBar: 17
};
export var commonAudioComponentTypes = {
    bgm: 6,
    soundEffect: 15
};
// 素材仓库资源库类型
export var commonComponentTypes = _objectSpread({
    effect: 10,
    scene: 16
}, commonImageComponentTypes, commonAudioComponentTypes);
export var effectSubtype = {
    dragonBone: 1,
    xlz: 2,
    particle: 5,
    aImage: 3
};
// 图片资源的子类型，仅在前端使用
export var imageSubCategories = {
    // 背景图片
    bg: "bg"
};
// 粒子资源的子类型，仅在前端使用
export var effectSubCategories = {
    // 粒子节点的图片子节点
    particleImage: "particleImage"
};
export var tabNameList = {
    commonImage: "commonImage",
    myImage: "myImage",
    assetImage: "assetImage",
    projectImage: "projectImage",
    commonAudio: "commonAudio",
    myAudio: "myAudio",
    assetAudio: "assetAudio",
    projectAudio: "projectAudio",
    commonEffect: "commonEffect",
    myEffect: "myEffect",
    assetEffect: "assetEffect",
    projectEffect: "projectEffect",
    commonBgm: "commonBgm",
    myBgm: "myBgm",
    commonScene: "commonScene",
    myVideo: "myVideo",
    assetVideo: "assetVideo",
    projectVideo: "projectVideo",
    commonText: "commonText",
    playUnit: "playUnit",
    widgetLib: "widgetLib"
};
export var libTabNameList;
(function(libTabNameList) {
    libTabNameList["COMMON"] = "common";
    libTabNameList["ASSET"] = "asset";
    libTabNameList["PROJECT"] = "project";
})(libTabNameList || (libTabNameList = {}));
export var libFrom;
(function(libFrom) {
    libFrom["POOL"] = "pool";
    libFrom["IVVIDEO"] = "ivVideo";
    libFrom["LIB"] = "lib";
    libFrom["POOLUPDATE"] = "poolUpdate";
})(libFrom || (libFrom = {}));
var filterAssetTab = function(tabList) {
    var filterType = isAssetMode ? 1 : 2;
    return tabList.filter(function(item) {
        return item.type === filterType || item.type === 3 || typeof item.type === "undefined";
    });
};
export var commonTabList = [
    {
        text: i18n.t("ps.resourcePool.publicAssetLibrary"),
        key: libTabNameList.COMMON,
        tabList: [
            {
                key: "image",
                text: i18n.t("ps.resourcePool.assetTab.image")
            },
            {
                key: "aImage",
                text: i18n.t("ps.resourcePool.assetTab.aImage")
            },
            {
                key: "bgm",
                text: i18n.t("ps.resourcePool.assetTab.bgm")
            },
            {
                key: "audio",
                text: i18n.t("ps.resourcePool.assetTab.audio")
            },
            {
                key: "effect",
                text: i18n.t("ps.resourcePool.assetTab.particle")
            }, 
        ]
    },
    {
        text: i18n.t("ps.resourcePool.myAssetLibrary"),
        key: libTabNameList.ASSET,
        tabList: [
            {
                key: "image",
                text: i18n.t("ps.resourcePool.assetTab.image")
            },
            {
                key: "aImage",
                text: i18n.t("ps.resourcePool.assetTab.aImage")
            },
            {
                key: "video",
                text: i18n.t("ps.resourcePool.assetTab.video")
            },
            {
                key: "audio",
                text: i18n.t("ps.resourcePool.assetTab.audio")
            }, 
        ]
    }, 
];
export var projectTabList = [
    {
        text: i18n.t("ps.resourcePool.projectAssetLibrary"),
        key: libTabNameList.PROJECT,
        tabList: [
            {
                key: "all",
                text: i18n.t("ps.resourcePool.assetTab.all"),
                accept: Array.from(new Set(Object.values(ResourceAccepts).filter(function(item) {
                    return item;
                }))).join(",")
            },
            {
                key: "video",
                text: i18n.t("ps.resourcePool.assetTab.video"),
                accept: ResourceAccepts[ResourceCategory.VIDEO],
                category: [
                    ResourceCategory.VIDEO
                ]
            },
            {
                key: "audio",
                text: i18n.t("ps.resourcePool.assetTab.audio"),
                accept: ResourceAccepts[ResourceCategory.AUDIO],
                category: [
                    ResourceCategory.AUDIO
                ]
            },
            {
                key: "image",
                text: i18n.t("ps.resourcePool.assetTab.image"),
                accept: ResourceAccepts[ResourceCategory.IMAGE],
                category: [
                    ResourceCategory.IMAGE
                ]
            },
            {
                key: "aImage",
                text: i18n.t("ps.resourcePool.assetTab.aImage"),
                accept: "".concat(ResourceAccepts[ResourceCategory.DRAGON_BONE], ",").concat(ResourceAccepts[ResourceCategory.SEQUENCE_FRAME]),
                category: [
                    ResourceCategory.DRAGON_BONE,
                    ResourceCategory.SEQUENCE_FRAME, 
                ]
            }, 
        ]
    }, 
];
export var imageTabList = filterAssetTab([
    {
        text: i18n.t("workbench.resourceManagers.categoryList.image.commonImage"),
        key: tabNameList.commonImage
    },
    {
        text: i18n.t("workbench.resourceManagers.dialog.image"),
        key: tabNameList.myImage,
        type: 2
    },
    {
        text: i18n.t("ps.resourcePool.myAssetLibrary"),
        key: tabNameList.assetImage,
        type: 1
    },
    {
        text: i18n.t("ps.resourcePool.projectAssetLibrary"),
        key: tabNameList.projectImage,
        type: 3
    }, 
]);
export var videoTabList = filterAssetTab([
    {
        text: i18n.t("workbench.resourceManagers.dialog.video"),
        key: tabNameList.myVideo,
        type: 2
    },
    {
        text: i18n.t("ps.resourcePool.myAssetLibrary"),
        key: tabNameList.assetVideo,
        type: 1
    },
    {
        text: i18n.t("ps.resourcePool.projectAssetLibrary"),
        key: tabNameList.projectVideo,
        type: 3
    }, 
]);
export var aImageTabList = [
    {
        text: i18n.t("workbench.resourceManagers.categoryList.aImage.commonImage"),
        key: tabNameList.commonEffect
    },
    // {
    //   text: i18n.t('workbench.resourceManagers.dialog.aImage') as string,
    //   key: tabNameList.myEffect,
    // },
    {
        text: i18n.t("ps.resourcePool.myAssetLibrary"),
        key: tabNameList.assetEffect,
        type: 1
    },
    {
        text: i18n.t("ps.resourcePool.projectAssetLibrary"),
        key: tabNameList.projectEffect,
        type: 3
    }, 
];
var audioTabList = filterAssetTab([
    {
        text: i18n.t("workbench.resourceManagers.categoryList.audio.commonAudio"),
        key: tabNameList.commonAudio
    },
    {
        text: i18n.t("workbench.resourceManagers.dialog.audio"),
        key: tabNameList.myAudio,
        type: 2
    },
    {
        text: i18n.t("ps.resourcePool.myAssetLibrary"),
        key: tabNameList.assetAudio,
        type: 1
    },
    {
        text: i18n.t("ps.resourcePool.projectAssetLibrary"),
        key: tabNameList.projectAudio,
        type: 3
    }, 
]);
var particleTabList = [
    {
        text: i18n.t("workbench.resourceManagers.dialog.particleEffect"),
        key: tabNameList.commonEffect
    }, 
];
var BGMTabList = filterAssetTab([
    {
        text: i18n.t("workbench.resourceManagers.categoryList.bgm.commonBgm"),
        key: tabNameList.commonBgm
    },
    {
        text: i18n.t("workbench.resourceManagers.dialog.bgm"),
        key: tabNameList.myBgm,
        type: 2
    },
    {
        text: i18n.t("ps.resourcePool.myAssetLibrary"),
        key: tabNameList.assetAudio,
        type: 1
    },
    {
        text: i18n.t("ps.resourcePool.projectAssetLibrary"),
        key: tabNameList.projectAudio,
        type: 3
    }, 
]);
var emptyNodeCategory = {
    value: 99,
    label: i18n.t("workbench.resourceManagers.emptyNodeCategory.label"),
    icon: "gesture",
    ptIcon: IcClick,
    category: "emptyNode",
    text: i18n.t("workbench.resourceManagers.emptyNodeCategory.text")
};
export var categoryList = {
    resourcePool: {
        label: i18n.t("ps.resourcePool.projectAssetLibrary"),
        category: "resourcePool",
        icon: "ic_in_stock",
        ptIcon: IcInStock,
        text: i18n.t("ps.resourcePool.projectAssetLibrary"),
        tabList: projectTabList
    },
    commonResource: {
        label: i18n.t("ps.resourcePool.assetLibrary"),
        category: "commonResource",
        icon: "ic_asset_library",
        ptIcon: IcAssetLibrary,
        text: i18n.t("ps.resourcePool.assetLibrary"),
        tabList: commonTabList
    },
    image: {
        hidden: true,
        label: i18n.t("workbench.resourceManagers.categoryList.image.label"),
        icon: "pic",
        category: "image",
        ptIcon: IcImage,
        text: i18n.t("workbench.resourceManagers.categoryList.image.text"),
        tabList: imageTabList
    },
    video: {
        hidden: true,
        label: i18n.t("workbench.resourceManagers.categoryList.video.label"),
        icon: "video",
        category: "video",
        ptIcon: IcMovie,
        text: i18n.t("workbench.resourceManagers.categoryList.video.text"),
        tabList: videoTabList
    },
    aImage: {
        hidden: true,
        label: i18n.t("workbench.resourceManagers.categoryList.aImage.label"),
        icon: "seq",
        ptIcon: IcSeq,
        category: "aImage",
        text: i18n.t("workbench.resourceManagers.categoryList.aImage.text"),
        tabList: aImageTabList
    },
    audio: {
        hidden: true,
        label: i18n.t("workbench.resourceManagers.categoryList.audio.label"),
        icon: "voice",
        ptIcon: IcMusic,
        category: "audio",
        text: i18n.t("workbench.resourceManagers.categoryList.audio.text"),
        tabList: audioTabList
    },
    bgm: {
        hidden: true,
        label: i18n.t("workbench.resourceManagers.categoryList.bgm.label"),
        icon: "bgm",
        ptIcon: IcBgm,
        category: "bgm",
        text: i18n.t("workbench.resourceManagers.categoryList.bgm.text"),
        tabList: BGMTabList
    },
    text: {
        label: i18n.t("workbench.resourceManagers.categoryList.text.label"),
        icon: "word",
        ptIcon: IcWord,
        category: "text",
        text: i18n.t("workbench.resourceManagers.categoryList.text.text"),
        tabList: [
            {
                text: i18n.t("workbench.resourceManagers.dialog.text"),
                key: tabNameList.commonText
            }, 
        ]
    },
    effect: {
        hidden: true,
        label: i18n.t("workbench.resourceManagers.categoryList.effect.label"),
        icon: "effect",
        ptIcon: IcEffect,
        category: "effect",
        text: i18n.t("workbench.resourceManagers.categoryList.effect.text"),
        tabList: particleTabList
    },
    emptyNode: emptyNodeCategory,
    scene: {
        label: i18n.t("workbench.resourceManagers.categoryList.scene.label"),
        icon: "ending_template",
        ptIcon: IcScene,
        category: "scene",
        text: i18n.t("workbench.resourceManagers.categoryList.scene.text"),
        tabList: [
            {
                text: i18n.t("workbench.resourceManagers.categoryList.scene.label"),
                key: tabNameList.commonScene
            }, 
        ]
    },
    dragonBoneChild: {
        hidden: true,
        category: "dragonBoneChild"
    },
    globalVar: {
        label: i18n.t("workbench.resourceManagers.categoryList.globalVar.label"),
        icon: "GlobalVar",
        ptIcon: IcGlobalVariables,
        category: "globalVar",
        text: i18n.t("workbench.resourceManagers.categoryList.globalVar.text"),
        tabList: [
            {
                text: i18n.t("workbench.resourceManagers.categoryList.globalVar.label"),
                key: "globalVar"
            }, 
        ]
    },
    playUnit: {
        label: i18n.t("workbench.resourceManagers.categoryList.playUnit.label"),
        icon: "ic_components",
        ptIcon: IcComponents,
        category: "playUnit",
        text: i18n.t("workbench.resourceManagers.categoryList.playUnit.text"),
        tabList: [
            {
                text: i18n.t("workbench.resourceManagers.categoryList.widgetLib.label"),
                key: "widgetLib"
            },
            {
                text: i18n.t("workbench.resourceManagers.categoryList.playUnit.label"),
                key: "playUnit"
            }, 
        ]
    },
    quickLayout: {
        label: i18n.t("workbench.resourceManagers.categoryList.quickLayout.label"),
        icon: "quickLayout",
        ptIcon: IcPlayTemplate,
        // ptIcon: IcQuickTypesetting,
        category: "quickLayout",
        text: i18n.t("workbench.resourceManagers.categoryList.quickLayout.text"),
        tabList: [
            {
                text: i18n.t("workbench.resourceManagers.categoryList.quickLayout.label"),
                key: "quickLayout"
            }, 
        ]
    },
    ivUnit: {
        label: i18n.t("interactiveVideo.iv.interactiveComponent"),
        icon: "GlobalVar",
        ptIcon: IcInteraction,
        category: "ivUnit",
        text: i18n.t("interactiveVideo.iv.interactiveComponent"),
        tabList: [
            {
                text: i18n.t("interactiveVideo.iv.interactiveComponent"),
                key: "ivUnit"
            }, 
        ]
    }
};
export function getSubCategoryTitle(resource) {
    var config = [
        i18n.t("workbench.resourceManagers.categoryList.effect.dragonTxt"),
        i18n.t("workbench.resourceManagers.categoryList.effect.xlzTxt"),
        i18n.t("workbench.resourceManagers.categoryList.effect.particlesTxt"), 
    ];
    if (resource.sub_type) {
        return config[resource.sub_type - 1];
    }
    return "";
}
